__webpack_require__.p = "/nybygg/js/";